<template>
  <q-page>
    <h3 class="text-center">Add Stock from Group Order {{order.orderNumber}}</h3>
    <p class="text-center text-h5">{{order.filter}}</p>
    <p class="text-center text-h5" style="margin:0px; padding:0px">{{order.name }}</p>
    <br>    
    <p class="" style="font-size:16px;padding:20px; background-color:#f5f5f5; border:1px solid silver"><strong>Notes:</strong> <br>{{order.notes}}</p>
    <p v-if="order.addedStockFromBrandOrder" class="text-center" style="padding:20px; font-size: 25px;font-weight:bold; color:red">The items on this order has already been added to the stock</p>
    <br>
  <div class="row text-bold">
    <div style="width:160px; padding-left: 15px">
      <div>Exchange Rate:</div>             
      <q-input autofocus dense outlined v-model="fxrate" :rules="[ (val) => !!val || 'Exchange Rate required' ]"></q-input><br>
      <div>Variation Value:</div>            
      <q-input dense outlined v-model="variation" :rules="[ (val) => !!val || 'Variation value required' ]"></q-input>
    </div>
    <div style="width:160px; padding-left: 15px">        
      <div>Upsale:</div>
      <q-input dense outlined v-model="upsale" :rules="[ (val) => !!val || 'Upsale value required' ]"></q-input><br>
      <div>Retail % Increase:</div>
      <q-input suffix="%" dense outlined v-model="retailPriceIncrease" :rules="[ (val) => !!val || 'Value required' ]"></q-input> <br> 
    </div>
    <div style="padding-left: 50px">
      <q-toggle v-model="visibleColumns" val="brand" label="Brand" /><br>
      <q-toggle v-model="visibleColumns" val="reference" label="Reference" /><br>
      <q-toggle v-model="visibleColumns" val="range" label="Range" /><br>
      <q-toggle v-model="visibleColumns" val="colour" label="Colour" />      
    </div>
    <div style="padding-left: 50px">    
      <q-toggle v-model="visibleColumns" val="localPrice" label="Paid Price AUD" /><br>
      <q-toggle v-model="visibleColumns" val="inStock" label="Current Stock" /><br>
      <q-toggle v-model="visibleColumns" val="currentRetailPrice" label="Current Retail Price" /><br>
      <q-toggle v-model="visibleColumns" val="currentStockPrice" label="Current Stock Price" />      
    </div>
    <div style="padding-left: 50px">
      <q-toggle v-model="visibleColumns" val="newStock" label="New Total Stock" /><br>
      <q-toggle v-model="visibleColumns" val="calculatedRetailPrice" label="New Retail Price" /><br>
      <q-toggle v-model="visibleColumns" val="calculatedStockPrice" label="New Stock Price" /><br><br>
    </div>
    <div style="padding-left: 50px">
      <br>
      <q-checkbox label="Select All to Show in Retail" dense v-model="showRetailSelectAll" @input="v => updateRetailSelectAll(v)" /><br><br>
      <q-checkbox label="Select All to Hide in Stock" dense v-model="hideStockSelectAll" @input="v => updateStockSelectAll(v)" />
    </div>                       
  </div>
  <hr>
    <q-table
        :data="items()"
        :columns="columns()"
        :pagination="{rowsPerPage: 0}"
        binary-state-sort
        flat
        hide-bottom
        :visible-columns="visibleColumns"          
        row-key="name" >
        <template v-slot:body-cell-reference="props">
        <q-td :props="props">
          <router-link :to="`/admin/products/${((props.row.sku||{}).product||{}).id}`">{{props.value}}</router-link>
        </q-td>
        </template>
        <template v-slot:body-cell-receivedQty="props">
        <td props="props">
            <div style="width:100px; margin:auto">  
            <q-input :min="0" :value="props.value" @input="updateQty(props.row.id,$event)" id="cu" class="cui" maxlength="5" dense outlined input-style="font-weight:bold; text-align:center; width:40px; margin-left: -5px; margin-right:-50px; padding: 0" >
                <template v-slot:prepend>
                <q-btn class="minusButton" @click="removeOne(props.row.id)" size="10px" color="black" stretch  flat icon="remove" style="width: 25px; height: 30px; margin-left: -12px" />
                </template>
                <template v-slot:append>
                <q-btn class="plusButton"  @click="addOne(props.row.id)" size="10px" color="black" stretch  flat icon="add" style="width: 25px; height: 30px; margin-right: -12px" />
                </template>
            </q-input>
            </div>
        </td>
        </template>
        <template v-slot:body-cell-paidPrice="props">
          <td props="props">
            <div style="width:100px; margin:auto"> 
              <q-input class="cui" tabindex="1" outlined dense v-model="paidPrice[props.row.id]" @input="updatePaidPrice(props.row.id,$event)" style="width:120px" input-style="font-weight:bold; text-align:center; padding: 0" ></q-input>
            </div>
          </td>
        </template>

        <template v-slot:body-cell-showInRetail="props">
          <q-td :props="props">
            <q-checkbox dense :value="props.value" @input="v => updateShowInRetail(props.row.id,v)"></q-checkbox>
          </q-td>
        </template>

        <template v-slot:body-cell-hideInStock="props">
          <q-td :props="props">
            <q-checkbox dense :value="props.value" @input="v => updateHideInStock(props.row.id,v)"></q-checkbox>
          </q-td>
        </template>


    </q-table>
    <br>
    <div class="text-center" style="margin: 50px" >
      <q-btn @click="editAllSkus" :disable="disableAll" color="primary" class="text-bold">Process New Stock</q-btn>
    </div>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import { csv } from 'csvtojson'
import saveAs from 'file-saver'
import adminNotifyError from '../../util/adminNotifyError'
import notifyMessage from '../../util/notifyMessage'
import { colourToString, formatCurrency } from '../../util/string'
import { faVoteYea } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'PageAdminAddStockdFromOrder',
  apollo: {
    order () {
      return {
        query: gql`
        query brandOrder ($id: ID!) {
          brandOrder (id: $id) {
            id
            orderNumber
            filter

            groupOrder {
              id
              name
              isOpen
            }

            name
            notes
            createdAt
            totalCost

            generated
            verified
            submitted
            verifiedAtManufacturer
            manufactured
            shipped
            arrived
            checked
            packed
            dispatched
            clientReceived
            addedStockFromBrandOrder
            customerOrder {
              id
              account {
                id
                companyName
              }
            }

            items {
              id
#              skuId
              sku {
                  id
                  options
                  price
                  retailPrice 
                  stock
                  showInContainer
                  hideInStock
                  showInRetail                  
                  product {
                      id
                      name
                      reference
                      attributes
                      images {
                        url
                      }
                      urlSlug
                  }
              }
              qty
              notes
              itemCost
              totalCost
            }
          }
        }
      `,
        variables: {
          id: this.id
        },
        update (result) {
          result.brandOrder.items.forEach(item => {
            item.paidPriceAUD = 0;
            item.newRetailPrice = 0;
            item.newTotalStock = 0;
          })
          return result.brandOrder
        },
        fetchPolicy: 'network-only'
      }
    }
  },  
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    async getOrder(){
        let response = await this.$apollo.query({
          query: gql`
        query brandOrder ($id: ID!) {
          brandOrder (id: $id) {
            id
            orderNumber
            filter

            groupOrder {
              id
              name
              isOpen
            }

            name
            notes
            createdAt
            totalCost

            generated
            verified
            submitted
            verifiedAtManufacturer
            manufactured
            shipped
            arrived
            checked
            packed
            dispatched
            clientReceived
            addedStockFromBrandOrder
            customerOrder {
              id
              account {
                id
                companyName
              }
            }

            items {
              id
#              skuId
              sku {
                  id
                  options
                  price
                  retailPrice
                  showInContainer
                  hideInStock
                  showInRetail
                  stock
                  product {
                      id
                      name
                      reference
                      attributes
                      images {
                        url
                      }
                      urlSlug
                  }
              }
              qty
              notes
              itemCost
              totalCost
            }
          }
        }
      `,
        variables: {
          id: this.id
        },
        fetchPolicy: 'network-only'         
        })       
        return response.data.brandOrder
    },
    async editAllSkus () {
      //preparation
      let changes = [];
      let missing = []; 
      let skipSKU = [];
      
      this.order.items.forEach(item=>{
        console.log('ITEM:',item.sku.id,"this.calculatedPrice[item.id]",this.calculatedPrice[item.id],"this.calculatedQty[item.id]",this.calculatedQty[item.id],'isNaN(this.calculatedQty[item.id]',isNaN(this.calculatedQty[item.id]))

        if(this.quantity[item.id] == 0){
          return;
        }
        
        if(item.sku.id && this.calculatedPrice[item.id] && this.calculatedQty[item.id] && !isNaN(this.calculatedQty[item.id])){
          changes.push({
            id:item.sku.id,
            changes:{
              stock:this.calculatedQty[item.id],
              price: this.calculatedPrice[item.id],
              retailPrice: this.calculatedRetailPrice[item.id],
              hideInStock: item.sku.hideInStock,
              showInRetail: item.sku.showInRetail
            }
          })
        }else{
          missing.push(item.id)
        }
      });
      console.log('CHANGES',changes);
      
      //verification
      if(missing.length > 0){
        adminNotifyError(this.$q, 'Invalid price set on a item.', {message:""})
        return
      }

      //re-call the order again an compare the stock available just before updating it.
      let recalledOrder = await this.getOrder();

      recalledOrder.items.forEach(vItem => {
        let itemOnOrder = this.getItemById(vItem.id);
        if(itemOnOrder.sku.stock != vItem.sku.stock){
          skipSKU.push(itemOnOrder.sku.id);
        }
      });

      this.$q.dialog({
        title: 'Are these details correct?',
        message: `
          Exchange Rate: <strong>${this.fxrate||"EMPTY"}</strong><br>
          Variation Value: <strong>${this.variation||"EMPTY"}</strong><br>
          Upsale Rate: <strong>${this.upsale||"EMPTY"}</strong><br>
        `,
        html: true,
        cancel: true
      }).onOk(async(value) => {
        const promises = []
        this.disableAll = true;
        await this.makeNewBackup();
        changes.forEach(async (sku) => {
          if(!skipSKU.includes(sku.id)){
            promises.push(await this.editSku(sku.id, sku.changes))
          }
        })
        await Promise.all(promises);
        await this.setStockAddedFromBrandOrder (this.order.id);
        notifyMessage(this.$q,"","Stock Updated");
      })
    },
    async editSku (skuId, changes) {
      // {"operationName":"editSku","variables":{"id":"5de9a8e5017f7816e4052045","input":{"stock":1}},"query":"mutation editSku($id: ID!, $input: SkuInput!) {\n  editSku(id: $id, input: $input) {\n    id\n    stock\n    __typename\n  }\n}\n"}
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation editSku ($id: ID!, $input: SkuInput!) {
            editSku(id: $id, input: $input) {
              id
              attributes
              barcode
              options
              price
              containerPrice
              retailPrice
              showInContainer
              showInRetail
              hideInStock
              stock
            } 
          }
        `,
          variables: {
            id: skuId,
            input: changes
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to edit sku.', error)
      }
    },
    updateQty(id,v){
      let i = this.getItemById(id)
      this.$set(this.quantity,id,v)
      i.qty = v;
    },
    addOne (id){
      let i = this.getItemById(id);
      let v =  Number(i.qty) + 1
      i.qty = v;
      this.$set(this.quantity,id,v)
    },
    removeOne(id){
      let i = this.getItemById(id);
      let v =  Number(i.qty) - 1;
      if(!v || v < 0){
        v = 0;
      }
      i.qty = v;
      this.$set(this.quantity,id,v)
    },
    updateHideInStock (id,v){
      let item = this.getItemById(id)
      item.sku.hideInStock = v
      console.log('ITEM',item);  
    },
    updateShowInRetail (id,v){
      let item = this.getItemById(id)
      item.sku.showInRetail = v
      console.log('ITEM',item);
    },
    updateRetailSelectAll(v){
      this.order.items.forEach(item => {
        item.sku.showInRetail = v
      })
    },
    updateStockSelectAll(v){
      this.order.items.forEach(item => {
        item.sku.hideInStock = v
      })
    },          
    calculateStockPrice(id){
      let item = this.getItemById(id);
      // let newQty = item.qty;
      let receivedQty = Number(this.quantity[id])
      let inStock = Number(item.sku.stock)  
      let inStockPrice = Number(item.sku.price)
      let paidPrice = Number(this.paidPrice[id]);
      let upsale = Number(this.upsale);
      let fxrate = Number(this.fxrate);
      let variation = Number(this.variation);
      let calculatedFXPrice = paidPrice * ( fxrate + variation );
      item.paidPriceAUD = calculatedFXPrice

      if(receivedQty > 0) {
        this.calculatedPrice[id] = ((calculatedFXPrice * upsale * receivedQty) + (inStock * inStockPrice)) / (receivedQty + inStock) || 0;

        this.calculatedQty[id] = Number(receivedQty + inStock);

        item.newTotalStock =  this.calculatedQty[id];

        let newRetailPrice  = this.calculatedPrice[id] * (this.retailPriceIncrease/100 + 1);
        item.newRetailPrice = newRetailPrice;
   
        this.calculatedRetailPrice[id] = newRetailPrice;
        return this.calculatedPrice[id] || 0;
      }else{
        this.calculatedPrice[id] = inStockPrice;
        this.calculatedQty[id] = Number(inStock);
        item.newTotalStock =  this.calculatedQty[id];
        item.newRetailPrice = Number(item.sku.retailPrice);
        this.calculatedRetailPrice[id] = Number(item.sku.retailPrice);
        return this.calculatedPrice[id] || 0;
      } 



    },
    async setStockAddedFromBrandOrder (id) {
      const result = await this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!) {
            setStockAddedFromBrandOrder (id: $id)
          }
        `,
        variables: {
          id: id
        }
      })
      return result.data.setStockAddedFromBrandOrder
    },    
    updatePaidPrice(id,e){     
        this.paidPrice[id] = e;
    },
    getItemById(id){
      let foundIndex = this.order.items.findIndex(item => item.id == id);     
      return this.order.items[foundIndex];  
    },
    items (){
        if(this.order.items && !this.set){
          this.order.items.forEach(async (item) => {
            this.quantity[item.id] = item.qty
          })
          this.set = true;
        }
        return this.order.items;
    },
    async makeNewBackup () {
      await this.$apollo.mutate({
        mutation: gql`mutation createBackup {
          createBackup
        }`
      })
      this.$q.dialog({
        title: 'Backup Created!',
        message: `Successfully created a new backup.`
      })
    },    
    columns (){
        return [
      // { name: 'img', field: row => row.sku?.product?.images?.[0]?.url },
      { name: 'brand', label: 'Brand', field: row => row.sku?.product?.attributes?.brand, sortable: true, align: 'left' },                
      { name: 'name', label: 'Name', field: row => row.sku?.product?.name || 'Not Found', sortable: true, align: 'left' },
      { name: 'reference', label: 'Reference', field: row => row.sku?.product?.reference, sortable: true, align: 'left' },
      { name: 'range', label: 'Range', field: row => row.sku?.product?.attributes?.range, sortable: true, align: 'left' },
      // { name: 'size', label: 'Size', field: row => row.sku?.product?.attributes?.size, sortable: true },
      // { name: 'grip', label: 'Grip', field: row => row.sku?.product?.attributes?.grip, sortable: true },
      // { name: 'colour', label: 'Colour', field: row => colourToString(row.sku?.options?.colour), sortable: true, align: 'left' },
      { name: 'colour', label: 'Colour', field: row => colourToString(row.sku?.options?.colour), sortable: true, align: 'left' },
      // { name: 'holds', label: 'Holds', field: row => Number(row.sku?.product?.attributes?.holds), sortable: true, align: 'right' },
      // { name: 'price', label: 'Customer Price', field: row => Number(row.sku?.price), sortable: true, format: formatCurrency },
      { name: 'receivedQty', label: 'Received Qty', field: row => Number(row.qty), sortable: true, align: 'center' },
      { name: 'paidPrice', label: 'Paid Price', field: row => Number(row.paidPrice), sortable: true, format: formatCurrency,align: 'center' },
      { name: 'localPrice', label: 'Paid Price AUD', field: row => Number(row.paidPriceAUD) || 0, sortable: true, format: formatCurrency,align: 'center' },
      { name: 'inStock', label: 'Current Stock', field: row => row.sku?.stock, sortable: true,align: 'center' },
      { name: 'currentStockPrice', label: 'Current Stock Price', field: row => Number(row.sku?.price), sortable: true, format: formatCurrency,align: 'center' },
      { name: 'currentRetailPrice', label: 'Current Retail Price', field: row => Number(row.sku.retailPrice), sortable: true, format: formatCurrency,align: 'center' },
      { name: 'newStock', label: 'Total New Stock', field: row => row.newTotalStock, sortable: true,align: 'center',style:"font-weight:bold;background-color:#f0ffeb" },      
      { name: 'calculatedStockPrice', label: 'New Stock Price (Unit)', field: row => Number(this.calculateStockPrice(row.id)), sortable: true, format: formatCurrency, style:"font-weight:bold;background-color:#f0ffeb" },
      { name: 'calculatedRetailPrice', label: `New Retail Price (${this.retailPriceIncrease} % +)`, field: row => Number(row.newRetailPrice) || 0, sortable: true, format: formatCurrency,align: 'center', style:"font-weight:bold;background-color:#f0ffeb"},
      { name: 'showInRetail', label: 'Show In Retail', align: 'center', field: row => row.sku.showInRetail || false, sortable: true },
      { name: 'hideInStock', label: 'Hide In Stock', align: 'center', field: row => row.sku.hideInStock || false, sortable: true }
     ]
    },
  },
  data () {
    return {
      visibleColumns: ['brand', 'name','reference', 'range', 'colour', 'receivedQty', 'paidPrice', 'localPrice', 'inStock','currentRetailPrice','currentStockPrice','newStock','calculatedRetailPrice','calculatedStockPrice','showInRetail','hideInStock'],
      order: {},
      orderVerification:{},
      fxrate: '',
      upsale: 2.2,
      orderItems: {},
      paidPrice:{},
      calculatedFXPrice:{},
      calculatedRetailPrice:{},
      calculatedPrice:{},
      calculatedQty:{},
      modHideInStock:{},
      modShowInRetail:{},
      quantity:{},
      variation: 0.05,
      retailPriceIncrease: 10,//10%
      set:false,
      disableAll:false,
      showRetailSelectAll:false,
      hideStockSelectAll:false, 
    }
  }
}
</script>
